import { render, staticRenderFns } from "./Selector.vue?vue&type=template&id=96e3eb84&scoped=true&"
import script from "./Selector.vue?vue&type=script&lang=js&"
export * from "./Selector.vue?vue&type=script&lang=js&"
import style0 from "./Selector.vue?vue&type=style&index=0&id=96e3eb84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96e3eb84",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('96e3eb84')) {
      api.createRecord('96e3eb84', component.options)
    } else {
      api.reload('96e3eb84', component.options)
    }
    module.hot.accept("./Selector.vue?vue&type=template&id=96e3eb84&scoped=true&", function () {
      api.rerender('96e3eb84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Contact/Selector.vue"
export default component.exports